"use client";

import { useRouter } from "next/navigation";

export default function PokerError({ error, reset }: { error: Error; reset: () => void }) {
  const router = useRouter();

  return (
    <div className="flex min-h-[100dvh] flex-col items-center justify-center poker-bg-gradient poker-suit-pattern p-4">
      <div className="text-center space-y-4 max-w-sm">
        <h2 className="text-xl font-bold text-white">Something went wrong</h2>
        <p className="text-sm" style={{ color: "#8a86c8" }}>
          {error.message || "An unexpected error occurred."}
        </p>
        <div className="flex gap-3 justify-center">
          <button
            onClick={reset}
            className="poker-btn-game poker-btn-game--sm poker-btn-game--green px-5 py-2 text-sm"
          >
            Try Again
          </button>
          <button
            onClick={() => router.push("/poker")}
            className="poker-btn-game poker-btn-game--sm poker-btn-game--dark px-5 py-2 text-sm"
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}
